import { CommonModule } from '@angular/common';
import { EventEmitter, Input, Output } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { IApp } from '@core/models/app.interfaces';
import { TranslateModule } from '@ngx-translate/core';
import { BaseActionsComponent } from '@shared/components/base-actions/base-actions.component';
import { NgSelectModule } from '@shared/components/ng-select/ng-select.module';
import { WCAGLabelDirective } from '@shared/directives/wcag-label.directive';
import { HelperService } from '@shared/services/helper.service';

@Component({
  selector: 'app-manage-facilities-actions',
  templateUrl: './manage-facilities-actions.component.html',
  styleUrls: ['./manage-facilities-actions.component.scss'],
  imports:[NgSelectModule, TranslateModule, CommonModule, WCAGLabelDirective, FormsModule]
})
export class ManageFacilitiesActionsComponent extends BaseActionsComponent implements OnInit {
 
  @Input() actionsList: IApp.IEntityAction[];
  @Input() data: any;
  @Input() appendTo: string;
  @Output() actionSuccessfull = new EventEmitter<boolean>();

  constructor(private helperService: HelperService,private router: Router) { super(); }

  ngOnInit() {
    this.actionsList.forEach(option => option.label = this.translateService.instant(`COMMON.actionsLabel.${option.workflowAction}`));
  }

  triggerActionController(value: IApp.IEntityAction): void {
    switch(value.workflowAction) {
      case 'VIEW':
        this.router.navigate(this.helperService.getTranslatedPath(`/manage-facilities/facility-detail/${this.data.id}`));
        break;
    }
  }


}
